import { getMypageFollowUserId } from "src/api/v1/mypage/follow/[user_id]/get"
import { MypageFollowUserIdGetInputModel } from "src/api/v1/mypage/follow/[user_id]/GetInputModel"

export const getIsFollowing = (userId: string): Promise<boolean> => {
  const model = new MypageFollowUserIdGetInputModel(userId)

  return getMypageFollowUserId(model).then((res) => res.is_follow)
}
